<!-- by 7527189 2 0 -->
<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle1" :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <!-- 搜索区域 -->
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="关键词" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入产品名称" v-model="topQueryParam.accumulateParam"></a-input>
                </a-form-item>
              </a-col>
              <!-- <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="操作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="请选择操作类型" v-model="queryParam.operType">
                    <a-select-option value="0">PC端</a-select-option>
                    <a-select-option value="1">移动端</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="批次号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入批次号" v-model="topQueryParam.batchNumber"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24">
                <a-form-item label="退货单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入退货单号" v-model="topQueryParam.number"></a-input>
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                  <a @click="handleToggleSearch" style="margin-left: 8px">
                    {{ toggleSearchStatus ? '收起' : '展开' }}
                    <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
                  </a>
                </a-col>
              </span>
              <!-- <a-col :md="8" :lg="6"  :sm="24" v-if="isystem==1">
                <a-form-item label="所属仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.depotId" placeholder="请选择所属仓库">
                    <a-select-option v-for="it in depotList" :value="it.id">{{it.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="8" :lg="6"  :sm="24" v-if="isystem==1">
                <a-form-item label="退货类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select v-model="queryParam.operType" placeholder="请选择退货类型">
                    <a-select-option v-for="it in typeList" :value="it.id">{{it.name}}</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col> -->
              <template v-if="toggleSearchStatus">
                <a-col :md="8" :lg="6"  :sm="24">
                  <a-form-item label="接收时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker style="width:100%" v-model="topQueryParam.createTime" format="YYYY-MM-DD"
                      :placeholder="['开始时间', '结束时间']" @change="onDateChange" @ok="onDateOk" />
                  </a-form-item>
                </a-col>
              </template>
            </a-row>
          </a-form>
        </div>
        <!-- 操作按钮区域 -->
        <div class="table-operator" style="margin-top: 5px">
          <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleAdd" type="primary" icon="plus">新增</a-button>
          <a-button v-if="btnEnableList.indexOf(1) > -1" @click="handleImportXls()" type="primary"
            icon="import">导入</a-button>
          <a-button type="primary" icon="download" @click="$refs.exportConfirmDate.show(handleExportXls,'商品信息')">导出</a-button>
        </div>
        <!-- table区域-begin -->
<!--        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange, columnWidth: '2%' }"-->
        <div>
          <a-table ref="tuihuotable" size="middle" bordered rowKey="id" :columns="columns" :dataSource="dataSource"
            :pagination="ipagination"  :scroll="{ x: true }"  :loading="loading"

            @change="handleTableChange">
            <span slot="action" slot-scope="text, record">
              <a @click="handledetail(record)">查看</a>
              <br>
              <a-divider v-if="btnEnableList.indexOf(1) > -1" type="vertical" />
              <a-popconfirm v-if="btnEnableList.indexOf(1) > -1" title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                <a>删除</a>
              </a-popconfirm>
            </span>
            <template slot="Ctotal" slot-scope="text, record">
              <div class="box">
                <span class="text">{{ count(record.info) }}</span>
              </div>
            </template>
            <span slot="createTime" slot-scope="text, record">
              {{ timestampToTime(record.createTime) }}
            </span>
            <span slot="counts" slot-scope="text, record">
              {{ record.counts ? record.counts : 0 }}
            </span>
            <span slot="number" slot-scope="text, record">
              <span class="elementButtonText" @click="openNumberLook(record)">{{ record.number }}</span>
            </span>
            <span slot="type" slot-scope="text, record">
              <span v-if="record.type == 0">批次出库</span>
              <span v-if="record.type == 1">扫码出库</span>
            </span>
            <span slot="operType" slot-scope="text, record">
              <span v-if="record.operType == 0">企业退货</span>
              <span v-if="record.operType == 1">经销商退货</span>
            </span>
            <template slot="name" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.materialName }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>
            <template slot="pName" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.pName }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>
            <template slot="udiName" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.udiName }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>
            <template slot="batchNumber" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.batchNumber }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>
            <template slot="packSpec" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.packSpec }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>
            <template slot="quantity" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.quantity }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>

            <template slot="quantitySpec" slot-scope="text, record">
              <template v-for="(it, idx) in record.info">
                <div class="text">{{ it.quantitySpec }}</div>
                <a-divider v-if="record.info.length != 1 && idx != record.info.length - 1" />
              </template>
            </template>

            <template slot="createByName" slot-scope="text, record">
              <span v-if="record.createByName">
                {{record.createByName}}
              </span>
              <span v-else>
                内含多个
              </span>
            </template>


            <span slot="action" slot-scope="text, record">
              <a @click="detail(record)">详情</a>
            </span>

            <!-- <template slot="customRenderEnabled" slot-scope="enabled">
              <a-tag v-if="enabled" color="green">启用</a-tag>
              <a-tag v-if="!enabled" color="orange">禁用</a-tag>
            </template> -->
          </a-table>
        </div>
        <!-- table区域-end -->
        <!-- 表单区域 -->
        <import-file-modal ref="modalImportForm" @ok="modalFormOk"></import-file-modal>
        <returnModel ref="IndetailModelref" @ok="modalFormOk"></returnModel>
        <UDIOutlistDialogNew ref="UDIOutlistDialogNew"></UDIOutlistDialogNew>
        <returnGoodslistNewDialog ref="returnGoodslistNewDialog"></returnGoodslistNewDialog>
        <exportConfirmDate ref="exportConfirmDate" ></exportConfirmDate>
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import returnGoodslistNewDialog from './modules/returnGoodslistNewDialog'
import returnModel from './modules/returnModel'
import { queryMaterialCategoryTreeList, outexportExcel, getAddress, getAllListApp } from '@/api/api'
import { postAction, getFileAccessHttpUrl } from '@/api/manage'
import { getMpListShort } from '@/utils/util'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Vue from 'vue'
import JEllipsis from '@/components/jeecg/JEllipsis'
import UDIOutlistDialogNew from './modules/returnGoodslistDialogNew'
import { getUserID, getisystem } from '@/utils/auth.js'
export default {
  name: 'MaterialList',
  mixins: [JeecgListMixin],
  components: {
    returnModel,
    JEllipsis,
    UDIOutlistDialogNew,
    returnGoodslistNewDialog
  },
  data () {
    return {
      categoryTree: [],
      mPropertyListShort: '',
      model: {},
      labelCol: {
        span: 5,
      },
      wrapperCol: {
        span: 18,
        offset: 1,
      },
      // 查询条件
      isystem: '',
      typeList: [
        { name: '工厂退货', id: 0 },
        { name: '经销商退货', id: 1 },
      ],
      topQueryParam: {
        type: 2,
        accumulateParam: '',
        batchNumber: '',
        createTime: '',
        operType: undefined,
        number: '',
        createBy: getisystem() === 1 ? '' : getUserID(),
        beginTime: '2024-08-31',
        endTime:'2124-08-31'
        // userId: '',
      },
      ipagination: {
        pageSizeOptions: ['10', '20', '30', '50', '100', '200'],
      },
      // 实际表头
      columns: [],
      // 初始化设置的表头
      settingColumns: [
        'number','counts','receiverName','returnerName','quantity','receiverTime','remark','materialName','standard','batchNumber','quantity','quantitySpec'
      ],
      // 默认的列
      defColumns: [
        { title: '退货单号', dataIndex: 'number', width: 120, align: 'center', scopedSlots: { customRender: 'number' } },
        { title: '接收方操作人', dataIndex: 'receiverName', width: 90, align: 'center' },
        { title: '退货方', dataIndex: 'returnerName', width: 90, align: 'center' },
        { title: '产品名称', dataIndex: 'materialName', width: 150, align: "center"  },
        { title: '规格型号', dataIndex: 'standard', width: 150, align: "center" },
        { title: '批次号', dataIndex: 'batchNumber', width: 80, align: "center" },
        { title: '包装数量',  dataIndex: 'quantitySpec', width: 150, align: "center" },
        { title: '产品数量', dataIndex: 'quantity', width: 80,align: "center" },
        { title: '扫码个数', dataIndex: 'counts', width: 80, scopedSlots: { customRender: 'counts' } },
        { title: '退货时间', dataIndex: 'receiverTime', width: 140, align: 'center', },
        { title: '退货原因', dataIndex: 'remark', width: 100, align: 'center' },
      ],
      url: {
        list: '/report/statisticsReturnStorage',
        delete: '/material/delete',
        deleteBatch: '/material/deleteBatch',
        importExcelUrl: '/report/exportExcelReturnStorage',
        exportXlsUrl: '/report/exportExcelReturnStorage',
        batchSetStatusUrl: '/material/batchSetStatus',
        batchSetMaterialCurrentStockUrl: '/material/batchSetMaterialCurrentStock',
      },
    }
  },
  created () {
    this.getdepotList()
    this.initColumnsSetting()
    console.log(this.$store.getters.userInfo, '用户信息')
    this.isystem = this.$store.getters.userInfo.isystem
    // this.queryParam.userId = this.$store.getters.userInfo.id
    // this.loadTreeData()
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}${this.url.importExcelUrl}`
    },
  },
  methods: {
    detail(record){
      this.$refs.returnGoodslistNewDialog.add(record, '详情')
    },
    openNumberLook (record) {
      this.$refs.UDIOutlistDialogNew.add(record.number, '退货')
    },
    async getdepotList () {
      const res = await getAllListApp({ userId: this.$store.getters.userInfo.id })
      console.log(res, 'res执行了---')
      if (res.code == 200 && res.data.rows) {
        this.depotList = res.data.rows
      }
    },
    async getaddress () {
      let params = {
        lon: '117.21855926513672',
        lat: '39.065635681152344',
      }
      const res = await getAddress(params)
      console.log(res, 'res')
    },
    numberDetail (uuid) {
      console.log(uuid, 'uuid')
      this.$refs.modaltree.show(uuid)
    },
    count (arr) {
      let num = 0
      arr.forEach((it) => {
        num += Number(it.quantity ? it.quantity : 0)
      })
      return num
    },
    handledetail (record) {
      console.log('1234')
      this.$refs.IndetailModelref.add(record)
    },
    onDateChange: function (value, dateString) {
      if(dateString[0] == ''){
        this.topQueryParam.beginTime = '2024-08-31'
        this.topQueryParam.endTime = '2124-08-31'
      }else{
        this.topQueryParam.beginTime = dateString[0]
        this.topQueryParam.endTime = dateString[1]
      }
    },
    //加载初始化列
    initColumnsSetting () {
      let columnsStr = Vue.ls.get('tuihuotable')
      if (columnsStr && columnsStr.indexOf(',') > -1) {
        this.settingColumns = columnsStr.split(',')
      }
      this.columns = this.defColumns.filter((item) => {
        if (this.settingColumns.includes(item.dataIndex)) {
          return true
        }
        return false
      })
    },

    loadTreeData () {
      let that = this
      let params = {}
      params.id = ''
      queryMaterialCategoryTreeList(params).then((res) => {
        if (res) {
          that.categoryTree = []
          for (let i = 0; i < res.length; i++) {
            let temp = res[i]
            that.categoryTree.push(temp)
          }
        }
      })
    },
    batchSetMaterialCurrentStock () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        let that = this
        this.$confirm('是否操作选中数据?', '确认操作', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(() => {
          that.loading = true
            postAction(that.url.batchSetMaterialCurrentStockUrl, { ids: ids })
              .then((res) => {
                if (res.code === 200) {
                  that.$message.info('修正库存成功！')
                  that.loadData()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.data.message)
                }
              })
              .finally(() => {
                that.loading = false
              })
        }).catch(() => {});
      }
    },
    batchEdit () {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！')
      } else {
        let ids = ''
        for (let a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ','
        }
        this.$refs.batchSetInfoModalForm.edit(ids)
        this.$refs.batchSetInfoModalForm.title = '批量编辑'
      }
    },
    handleEdit: function (record) {
      this.$refs.modalForm.edit(record)
      this.$refs.modalForm.title = '编辑'
      this.$refs.modalForm.disableSubmit = false
      if (this.btnEnableList.indexOf(1) === -1) {
        this.$refs.modalForm.isReadOnly = true
      }
    },
    getImgUrl (imgName) {
      if (imgName && imgName.split(',')) {
        return getFileAccessHttpUrl('systemConfig/static/' + imgName.split(',')[0])
      } else {
        return ''
      }
    },
    handleImportXls () {
      let importExcelUrl = this.url.importExcelUrl
      let templateUrl = '/doc/goods_template.xls'
      let templateName = '商品Excel模板[下载]'
      this.$refs.modalImportForm.initModal(importExcelUrl, templateUrl, templateName)
      this.$refs.modalImportForm.title = '商品导入'
    },
    searchReset () {
      this.topQueryParam = {
        type: 2,
        accumulateParam: '',
        batchNumber: '',
        createTime: '',
        operType: undefined,
        number: '',
        createBy: getisystem() === 1 ? '' : getUserID()
        // userId: '',
      }
      this.topQueryParam.beginTime = '2024-08-31'
      this.topQueryParam.endTime = '2124-08-31'
      // this.queryParam.userId = this.$store.getters.userInfo.id
      this.loadData(1)
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';

.text {
  /* display: inline-block; */
  height: 42px;
  display: flex;
  width: 100%;
  /* height: 100%; */
  align-items: center;
  justify-content: center;
  /* background-color: red; */
}

.elementButtonText {
  color: #409eff;
  cursor: pointer;
}
</style>